<template>
  <ShowViewForm insite="true" ref="showviewform" v-if="showViewFormData.list && showViewFormData.list.length > 0"
                :data="showViewFormData" :value="temp">
  </ShowViewForm>
</template>

<script>
import ShowViewForm from '@/components/Formcreated/components/ShowViewForm';
import * as forms from '@/api/forms';
import * as sysdealerinfos from '@/api/sysdealerinfos';

export default {
  name: 'usersview',
  components: { ShowViewForm },
  props: {
    commonObject: {
      type: Object,
      required: true
    },
    commonName: [String]
  },
  data() {
    return {
      temp: {},
      showViewFormData: {
        list: [],
        config: {}
      }
    };
  },
  watch: {
    commonObject: {
      deep: true,
      handler(val) {
        this.$refs.showviewform.reseltActiveName();
        this.InitDate();
      }
    }
  },
  created() {
    this.InitDate();
  },
  methods: {
    InitDate() {
      const temp = { ...this.temp, ...this.commonObject };
      var queryObj = { SourceCode: 'User' };
      forms.getCreeateFrom(queryObj).then(response => {
        this.showViewFormData = response.result.contentData && JSON.parse(response.result.contentData) || {};
        if (Object.keys(temp).includes('status')) {
          temp.status = temp.status + '';
        }
        sysdealerinfos.getByUser(temp.id).then(rep => {
          if (rep.result !== null) {
            temp.phoneNumber = rep.result.phoneNumber;
            temp.placeId = rep.result.placeId;
            temp.placeNm = rep.result.placeNm;
            temp.natureTp = rep.result.natureTp;
          }
          this.temp = { ...{}, ...temp };
        });
      }).catch(() => {
        // console.log(err)
      });
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
